import React from 'react';


const ExportCSVButton = ({ data, filename = 'export.csv' }) => {
    const handleExport = () => {
        if (!data || data.length === 0) {
            console.warn('No data available to export.');
            return;
        }

        const csvRows = [];

        // Get headers from the first object
        const headers = Object.keys(data[0]);
        csvRows.push(headers.join(','));

        // Convert each row to CSV format
        data.forEach(row => {
            const values = headers.map(header => `"${(row[header] ?? '').toString().replace(/"/g, '""')}"`);
            csvRows.push(values.join(','));
        });

        // Create a blob and trigger download
        const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <button
        type="button"
        className="btn btn-light-100 text-dark radius-8 px-11 py-6"
        onClick={handleExport}
    >
        Export
    </button>
    );
};

export default ExportCSVButton;
